import { MessageCircle, Phone } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const WHATSAPP_LINK =
  "https://wa.me/966540423401?text=Hello%20BlackRide%20%F0%9F%9A%98%0A%0AI%E2%80%99d%20like%20to%20book%20a%20ride.%0A%0APickup%3A%0ADrop%3A%0ADate%20%26%20Time%3A%0APassengers%3A%0A%0APlease%20confirm%20availability.";
const CALL_LINK = "tel:+966540423401";

export default function MobileStickyCTA() {
  const { lang } = useLanguage();
  const isArabic = lang === "ar";

  return (
    <div className="fixed bottom-4 inset-x-4 z-[60] md:hidden">
      <div className="grid grid-cols-2 gap-3 rounded-[24px] border border-white/10 bg-black/85 backdrop-blur-xl p-3 shadow-[0_20px_50px_rgba(0,0,0,0.45)]">
        <a
          href={WHATSAPP_LINK}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center justify-center gap-2 bg-[#C7A239] text-black font-semibold py-3 rounded-2xl"
          data-testid="sticky-whatsapp-cta"
          data-track="sticky_whatsapp_cta"
        >
          <MessageCircle className="w-4 h-4" />
          {isArabic ? "واتساب" : "WhatsApp"}
        </a>
        <a
          href={CALL_LINK}
          className="inline-flex items-center justify-center gap-2 border border-white/15 text-white font-medium py-3 rounded-2xl bg-white/5"
          data-testid="sticky-call-cta"
          data-track="sticky_call_cta"
        >
          <Phone className="w-4 h-4" />
          {isArabic ? "اتصال" : "Call"}
        </a>
      </div>
    </div>
  );
}
